// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modal_modalContainer__JK7cc","modalTitle":"modal_modalTitle__ckz_T","modalDescription":"modal_modalDescription__yIJpR","modalXButton":"modal_modalXButton__oCMcd"};